module.exports = __webpack_public_path__ + "img/icon-differentials_11.0db49a47.svg";